<script setup name="TvbDraggable">
import { ref, inject, nextTick, watch } from 'vue'
import { UseDraggable } from '@vueuse/components'

const size = inject('size')
const width = inject('width')
const handle = ref(null)
const draggableRef = ref()
const draggableContainerRef = ref()
const draggableMoveSetTimeout = ref(null)

defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  initialValue: {
    type: Object,
    default: null
  }
})

/** 边界处理 */
const draggableMove = () => {
  const { left, top, width, height } = draggableContainerRef.value.getBoundingClientRect()
  const headerEl = document.querySelector('.tvb-home-header')
  const draggableEl = draggableRef.value.$el
  if (left <= 0) {
    clearTimeout(draggableMoveSetTimeout.value)
    nextTick(() => {
      draggableEl.style.left = `0px`
      draggableMoveSetTimeout.value = setTimeout(() => {
        draggableEl.style.left = `1px`
      }, 100)
    })
  } else if (top <= headerEl.clientHeight || 0) {
    clearTimeout(draggableMoveSetTimeout.value)
    nextTick(() => {
      draggableEl.style.top = `${headerEl.clientHeight}px`
      draggableMoveSetTimeout.value = setTimeout(() => {
        draggableEl.style.top = `${headerEl.clientHeight + 1}px`
      }, 100)
    })
  } else if (left + width >= window.innerWidth) {
    clearTimeout(draggableMoveSetTimeout.value)
    nextTick(() => {
      draggableEl.style.left = `${window.innerWidth - width}px`
      draggableMoveSetTimeout.value = setTimeout(() => {
        draggableEl.style.left = `${window.innerWidth - width - 1}px`
      }, 100)
    })
  } else if (top + height >= window.innerHeight) {
    clearTimeout(draggableMoveSetTimeout.value)
    nextTick(() => {
      draggableEl.style.top = `${window.innerHeight - height}px`
      draggableMoveSetTimeout.value = setTimeout(() => {
        draggableEl.style.top = `${window.innerHeight - height - 1}px`
      }, 100)
    })
  }
}

watch(width, () => draggableMove())
</script>

<template>
  <use-draggable
    class="tvb-draggable"
    :class="{ disabled: disabled, mobile: ['s', 'xs'].includes(size) }"
    :initial-value="initialValue"
    :prevent-default="true"
    :handle="handle"
    ref="draggableRef"
    @move="draggableMove"
    :preventDefault="true"
  >
    <div class="tvb-draggable_container" ref="draggableContainerRef">
      <div ref="handle" class="tvb-draggable_cursor-move" v-show="!disabled" title="按此移動">
        <svg data-v-083f18dc="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
          <path
            fill="#fff"
            d="m186.496 544 41.408 41.344a32 32 0 1 1-45.248 45.312l-96-96a32 32 0 0 1 0-45.312l96-96a32 32 0 1 1 45.248 45.312L186.496 480h290.816V186.432l-41.472 41.472a32 32 0 1 1-45.248-45.184l96-96.128a32 32 0 0 1 45.312 0l96 96.064a32 32 0 0 1-45.248 45.184l-41.344-41.28V480H832l-41.344-41.344a32 32 0 0 1 45.248-45.312l96 96a32 32 0 0 1 0 45.312l-96 96a32 32 0 0 1-45.248-45.312L832 544H541.312v293.44l41.344-41.28a32 32 0 1 1 45.248 45.248l-96 96a32 32 0 0 1-45.312 0l-96-96a32 32 0 1 1 45.312-45.248l41.408 41.408V544H186.496z"
          ></path>
        </svg>
      </div>
      <slot />
    </div>
  </use-draggable>
</template>

<style lang="scss" scoped>
.tvb-draggable {
  width: max-content;
  height: max-content;
  position: fixed;
  z-index: 99999;
  &:not(.disabled) {
    &[style*='left: 0px'] {
      &[style*='top: 0px'] {
        left: max(
          calc(768px / 1920px * 100%),
          calc((100vw - 1280px) / 2 + (848px - 400px))
        ) !important;
        top: calc(100vh - 261px) !important; // 自身高度 + 36
        &.mobile {
          left: calc(100vw - 200px - 12px) !important;
          top: calc(100vh - 168px) !important; // 自身高度 + 56
        }
      }
    }
  }
  &.disabled,
  &.disabled.mobile {
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    height: unset !important;
    width: unset !important;
    z-index: unset !important;
  }
  .tvb-draggable_container {
    position: relative;
    width: 100%;
    height: 100%;
    .tvb-draggable_cursor-move {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 999;
      cursor: move;
      color: #fff;
      svg {
        width: 26px;
        height: 26px;
      }
    }
  }
}
</style>
